import { classCallCheck } from './class-call-check';
import { extend } from './extend';
import { mixin } from './mixin';

function Proto() {
  classCallCheck(this, Proto);
}

Proto.extend = extend;
Proto.mixin = mixin;

export { Proto };
